import React, { useEffect } from 'react';
import {
    useWeb3ModalAccount,
    createWeb3Modal,
    defaultConfig,
} from "@web3modal/ethers/react";

const projectId = "57c3ed3f7633af987eda789d503edfee"; // Replace with your Web3Modal project ID
const chains = [
    {
        chainId: 97, // BSC Testnet chain ID
        name: "Binance Smart Chain Testnet",
        currency: "BNB",
        explorerUrl: "https://testnet.bscscan.com",
        rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545", // BSC Testnet RPC URL
    },
];

const ethersConfig = defaultConfig({
    metadata: {
        name: "Web3Modal",
        description: "Web3Modal Laboratory",
        url: "https://web3modal.com",
        icons: ["https://avatars.githubusercontent.com/u/37784886"],
    },
    defaultChainId: 97, // Set to BSC Testnet chain ID
    rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545", // Default RPC for BSC Testnet
});

// Initialize Web3Modal
createWeb3Modal({
    ethersConfig,
    chains,
    projectId,
    enableAnalytics: true,
    themeMode: "dark",
    themeVariables: {
        "--w3m-accent": "rgba(0, 0, 0, 0)",
    },
});

const WalletConnection = ({ onConnected }) => {
    const { address: account, chainId } = useWeb3ModalAccount();
    const isBSC = chainId === 97; // Check if the connected chain is BSC Testnet

    // Detect wallet connection and trigger callback
    useEffect(() => {
        if (account && isBSC) {
            // console.log("Wallet connected:", account);
            if (onConnected) onConnected(account); // Trigger callback with the connected account
        }
    }, [account, chainId, isBSC, onConnected]);

    return (
        <div className="d-flex justify-content-center">
            <div className="p-0" style={{ backgroundColor: "rgba(255, 255, 255, 0)", color: 'black' }}>
                <w3m-button />
            </div>
        </div>
    );
};

export default WalletConnection;
